<template>
    <div>
        <div class="login">
            <div class="left">
                <img :src="$global.Image.icon_logo" alt="" class="logo" />
                <img :src="$global.Image.icon_company" alt="" class="company" />
            </div>
            <div class="right">
                <div class="title">登录</div>
                <div style="height:67px;"></div>
                <div class="li">
                    <img :src="$global.Image.icon_mine" alt="" />
                    <input
                        type="text"
                        placeholder="请输入登录账号/手机号"
                        v-model="mobile"
                    />
                </div>
                <div style="height:46px;"></div>
                <div class="li">
                    <img :src="$global.Image.icon_close" alt="" />
                    <input
                        type="password"
                        placeholder="请输入密码"
                        v-model="password"
                    />
                </div>
                <div class="btn" @click="login">立即登录</div>
                <div class="findpass" @click="findpass">忘记密码</div>
            </div>
        </div>
        <van-dialog v-model="show" style="width:430px">
            <img
                :src="$global.Image.kefu"
                class="kefu"
                style="width:70px;height:93px;margin:30px 0 17px 0;"
            />
            <div class="txt">请联系管理员</div>
            <div class="mobile">{{ custMobible }}</div>
        </van-dialog>
    </div>
</template>
<script>
export default {
    name: "login",
    data() {
        return {
            show: false,
            password: "",
            mobile: "",
            custMobible: ""
        };
    },
    methods: {
        findpass() {
            this.show = true;
        },
        login() {
            let params = {
                mobile: this.mobile,
                password: this.password
            };
            if (this.mobile == "" || this.password == "") {
                this.$alert("手机号或密码错误", "温馨提示", {
                    confirmButtonText: "确定",
                    callback: action => {}
                });
                return;
            }
            this.$post("/api/login/login", params).then(res => {
                if (res.code == 1) {
                    localStorage.setItem("mobile", res.data.mobile);
                    localStorage.setItem("token", res.data.token);
                    localStorage.setItem('username',res.data.name);
                    this.$toast(res.msg);
                    setTimeout(() => {
                        this.$router.replace("/appointment");
                    }, 1500);
                } else {
                    this.$alert(res.msg, "温馨提示", {
                        confirmButtonText: "确定",
                        callback: action => {}
                    });
                }
            });
        },
        /**客服电话 */
        customer() {
            this.$post("/api/login/forget_pass", "")
                .then(res => {
                    this.custMobible = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    mounted() {
        this.customer();
    }
};
</script>
<style lang="less" scoped>
.txt {
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #1c2833;
}
.mobile {
    opacity: 0.7;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #1c2833;
    padding: 27px 0 56px 0;
}
.login {
    width: 100%;
    height: 100vh;
    display: flex;
    .left {
        background: url("../assets/icon/icon_platform.png") no-repeat;
        background-size: 100% 100%;
        width: 60%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .logo {
            width: 346px;
            height: auto;
            margin-top: 66px;
        }
        .company {
            width: 898px;
            height: auto;
            position: absolute;
            bottom: 40px;
        }
    }
    .right {
        width: 40%;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;

        margin-top: 193px;
        .title {
            font-size: 26px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: center;
            color: #333333;
        }
        .li {
            width: 368px;
            display: flex;
            height: 54px;
            border-bottom: 1px solid #e6e6e6;
            img {
                width: 23px;
                height: 30px;
            }
            input {
                min-width: 189px;
                height: 25px;
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #999999;
                border: none;
                outline: none;
                padding-left: 20px;
            }
        }
        .btn {
            width: 368px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background: #3449d3;
            border-radius: 2px;
            font-size: 16px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            color: #ffffff;
            margin-top: 30px;
            cursor: pointer;
        }
        .findpass {
            width: 368px;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: right;
            color: #2178d6;
            padding-top: 20px;
            cursor: pointer;
        }
    }
}
</style>
